var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('Header'),_vm._v(" "),_c('AgencyContent'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('BackTop')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ca23f3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/layout/Agency.vue
// module id = null
// module chunks = 